import {
    Dialog, DialogTitle, DialogContent, DialogActions,
    Button, IconButton, Typography, Box
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import DownloadIcon from "@mui/icons-material/Download";
import { useTranslation } from 'react-i18next';

import DiscReportMuiFromData from "./DiscReportMuiFromData.js";

export default function DiscResultModal({ open, onClose, test }) {
    const { t } = useTranslation();
    console.log(test);
    const showEmpty = !test;
    const hasReportUrl = test?.reportUrl;

    const handleDownloadPDF = async () => {
        if (!hasReportUrl) return;

        try {
            const response = await fetch(test.reportUrl);
            const blob = await response.blob();
            const blobUrl = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = blobUrl;
            link.download = `reporte-disc-${test.applicantName || 'resultado'}.pdf`;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(blobUrl);
        } catch (error) {
            console.error('Error al descargar PDF:', error);
            window.open(test.reportUrl, '_blank');
        }
    };

    return (
        <Dialog open={open} onClose={onClose} maxWidth="lg" fullWidth>
            <DialogTitle>
                <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                    <Typography variant="h6">
                        {`${t('disc.discResults')}${test?.applicantName ? ` - ${test.applicantName}` : ""}`}
                    </Typography>
                    <IconButton onClick={onClose} size="small">
                        <CloseIcon />
                    </IconButton>
                </Box>
            </DialogTitle>

            <DialogContent dividers>
                {showEmpty ? (
                    <Typography variant="body2" color="text.secondary">
                        {t('disc.insufficientResponses')}
                    </Typography>
                ) : (
                    <DiscReportMuiFromData data={test} />
                )}
            </DialogContent>

            <DialogActions>
                <Button
                    startIcon={<DownloadIcon />}
                    variant="outlined"
                    onClick={handleDownloadPDF}
                    disabled={!hasReportUrl}
                >
                    {t('disc.downloadPdf')}
                </Button>
                <Button onClick={onClose}>{t('close')}</Button>
            </DialogActions>
        </Dialog>
    );
}